import { useMemo, useEffect } from 'react';
import { LangType } from '../../../../../../helpers/lang';
import { useLang } from '../../../../../../hooks/use-lang';
import { useBranchesStore } from '../../../../../../store/use-branch-store';
import { IdValue } from '../../../../../../types/props';
import { useQrStore } from '../../../../../../store/use-qr-store';

export const useQrSettings = () => {
  const { handleUpdateQr, qr } = useQrStore();
  const { fetchBranches, place } = useBranchesStore();
  const { getLocale, t } = useLang();

  const branches = useMemo(() => {
    return place?.map((item) => ({ id: String(item.id), value: getLocale(item.name) })) || [];
  }, [getLocale, place]);

  useEffect(() => {
    fetchBranches({ since_id: 0, n: 1000, customCache: true });
  }, [fetchBranches]);

  const handleChangeBranch = (e: IdValue) => {
    handleUpdateQr({ place_id: Number(e.id) });
  };

  const handleChangeName = (e: LangType) => {
    handleUpdateQr({ name: e });
  };

  const handleChangeDescription = (e: LangType) => {
    handleUpdateQr({ description: e });
  };

  const handleChangeIsDistance = () => {
    handleUpdateQr({ is_distance: !qr?.is_distance });
  };

  return {
    qr,
    branches,
    handleChangeBranch,
    handleChangeName,
    handleChangeDescription,
    handleChangeIsDistance,
    t,
  };
};
